import { render, staticRenderFns } from "./ContactGroups.vue?vue&type=template&id=154ebe76&scoped=true"
import script from "./ContactGroups.vue?vue&type=script&lang=js"
export * from "./ContactGroups.vue?vue&type=script&lang=js"
import style0 from "./ContactGroups.vue?vue&type=style&index=0&id=154ebe76&prod&lang=scss&scoped=true"
import style1 from "./ContactGroups.vue?vue&type=style&index=1&id=154ebe76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ebe76",
  null
  
)

export default component.exports